import React from 'react';
import { CAF_FINAL_RESPONSE_STANCES, CafFinalResponseStance } from '../../api/cafCorpus';
import { FINAL_RESPONSE_COPY, FINAL_RESPONSE_QUESTION } from './copy';

export interface FinalResponseSelectProps {
  id: string;
  value: CafFinalResponseStance | '';
  onChange: (next: CafFinalResponseStance | '') => void;
  disabled?: boolean;
  /** Short explanation shown under the question. */
  hint?: string;
}

/** The required "Is this a final response?" setting, shared by every form that saves an example. */
export const FinalResponseSelect: React.FC<FinalResponseSelectProps> = ({ id, value, onChange, disabled = false, hint }) => (
  <div className="cur-field">
    <label htmlFor={id}>{FINAL_RESPONSE_QUESTION}</label>
    <select id={id} className="cur-input" value={value} disabled={disabled} aria-required="true"
      aria-describedby={hint ? `${id}-hint` : undefined}
      onChange={(event) => onChange(event.target.value as CafFinalResponseStance | '')}>
      <option value="">Choose…</option>
      {CAF_FINAL_RESPONSE_STANCES.map((stance) => <option key={stance} value={stance}>{FINAL_RESPONSE_COPY[stance]}</option>)}
    </select>
    {hint && <span id={`${id}-hint`} className="cur-hint">{hint}</span>}
  </div>
);
